module.exports = __webpack_public_path__ + "static/media/menu.2ad0cd70.jpeg";